export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginPageView.vue'),
    meta: { requiresAuth: false, role: [] },
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: () => import('@/views/ChangePasswordView.vue'),
    meta: { requiresAuth: false, role: ['user', 'admin'] },
  },
  {
    path: '/admin/2fa',
    name: '2fa',
    component: () => import('@/views/TwoFactorAuthView.vue'),
    meta: { requiresAuth: false, role: ['admin'], adminOnly: true },
  },
]
